<div class="textblock">
  <div class="content">
    <ng-content></ng-content>
  </div>
  <div class="text-block-button  ">
    <!-- <img src="/img/textblock/button_audio.svg"> -->
    <div (click)="btnPlay()" class="button-image" [inlineSVG]="'/img/textblock/button_audio.svg'"></div>

  </div>
</div>
